import {fromJS} from 'immutable';


export default function reducer(
    state = fromJS({
        elementId: window.uuidv4(),
        errors: {},
    }),
) {
    return state;
}
